import * as Animate from "react-reveal";
import LeaderImg from "../../../assets/images/png/talent-leader.webp";
import PeopleImg from "../../../assets/images/png/utiva_people/3.webp";

const panels = [
  {
    image: LeaderImg,
    eyebrow: "Leadership in practice",
    title: "Experience that opens doors for the next generation.",
  },
  {
    image: PeopleImg,
    eyebrow: "People behind the platform",
    title: "Human ambition is the starting point.",
  },
];

const AboutDualImageSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {panels.map((panel) => (
            <Animate.Fade bottom key={panel.title}>
              <div
                className="relative rounded-2xl overflow-hidden"
                style={{ minHeight: "420px" }}
              >
                <img
                  src={panel.image}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "60%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.9))",
                  }}
                ></div>
                <div className="absolute z-10 bottom-6 left-6 right-6 font-poppins">
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-2">
                    {panel.eyebrow}
                  </p>
                  <h3 className="text-white text-xl md:text-2xl font-extrabold leading-tight m-0">
                    {panel.title}
                  </h3>
                </div>
              </div>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutDualImageSection;
